<form [formGroup]="frm" class="formGroup">
  <mat-form-field>
    <mat-label>Nueva contraseña</mat-label>
    <input
      #firstInput
      matInput
      [type]="hidePassword ? 'password' : 'text'"
      formControlName="password"
      (input)="matchPasswords()"
    />
    <button
      type="button"
      mat-icon-button
      matSuffix
      (click)="hidePassword = !hidePassword"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hidePassword"
    >
      <mat-icon [svgIcon]="hidePassword ? 'eye-off' : 'eye'"></mat-icon>
    </button>
    @if(password.hasError('required')){
      <mat-error>Campo requerido</mat-error>
    }
    @else if(password.hasError('minlength')){
      <mat-error>La contraseña debe contener más de {{password.errors!['minlength']['requiredLength']}} carácteres</mat-error>
    }
    @else if (password.hasError('pattern')) {
      <mat-error>La contraseña debe contener una letra en mayúscula, una en minúscula, un número y un carácter especial</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Repetir contraseña</mat-label>
    <input
      matInput
      [type]="hidePassword ? 'password' : 'text'"
      formControlName="confirmPassword"
      (input)="matchPasswords()"
    />
    <button
      type="button"
      mat-icon-button
      matSuffix
      (click)="hidePassword = !hidePassword"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hidePassword"
    >
      <mat-icon [svgIcon]="hidePassword ? 'eye-off' : 'eye'"></mat-icon>
    </button>
    @if(confirmPassword.hasError('required')){
      <mat-error>Campo requerido</mat-error>
    }
    @else if(confirmPassword.hasError('minlength')){
      <mat-error>La contraseña debe contener más de {{confirmPassword.errors!['minlength']['requiredLength']}} carácteres</mat-error>
    }
    @else if (confirmPassword.hasError('pattern')) {
      <mat-error>La contraseña debe contener una letra en mayúscula, una en minúscula, un número y un carácter especial</mat-error>
    } 
    @else if(confirmPassword.hasError('PasswordNoMatch')){
      <mat-error> La contraseñas no coinciden </mat-error>
    }
  </mat-form-field>
</form>
